export default "__VITE_ASSET__COBXkEya__"